/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ErrorV1Dto = {
  /**
   * Error code from the API error enum
   */
  key: ErrorV1Dto.key;
  /**
   * Name of the affected object/entity
   */
  object: string;
  /**
   * Name of the affected field (optional)
   */
  property?: string;
  /**
   * Error message (optional)
   */
  message?: string;
};
export namespace ErrorV1Dto {
  /**
   * Error code from the API error enum
   */
  export enum key {
    VALIDATION_FAILED = 'VALIDATION_FAILED',
    WRONG_VERSION = 'WRONG_VERSION',
    NOT_FOUND = 'NOT_FOUND',
    INVALID_REDIRECT_URL = 'INVALID_REDIRECT_URL',
    TICKET_POINT_OF_SALE_NOT_MATCHING = 'TICKET_POINT_OF_SALE_NOT_MATCHING',
    TICKET_DOCUMENT_ALREADY_ATTACHED = 'TICKET_DOCUMENT_ALREADY_ATTACHED',
    ALREADY_EXISTS = 'ALREADY_EXISTS',
    EMAIL_HAS_TICKET = 'EMAIL_HAS_TICKET',
    ATTACHMENT_HAS_TICKET = 'ATTACHMENT_HAS_TICKET',
    EMAIL_CLASSIFICATION_NOT_APPLICABLE = 'EMAIL_CLASSIFICATION_NOT_APPLICABLE',
    ATTACHMENT_CLASSIFICATION_NOT_APPLICABLE = 'ATTACHMENT_CLASSIFICATION_NOT_APPLICABLE',
    INDEX_PAYMENT_MISSING_FIELDS = 'INDEX_PAYMENT_MISSING_FIELDS',
    PAYMENT_HAS_INDEX_FIELDS = 'PAYMENT_HAS_INDEX_FIELDS',
    BREVO_API_KEY_NOT_FOUND = 'BREVO_API_KEY_NOT_FOUND',
    DOCUMENT_FIRST_REVIEWER_MISSING = 'DOCUMENT_FIRST_REVIEWER_MISSING',
    DUPLICATE = 'DUPLICATE',
  }
}
